// =====================================
//
//   補收款 點數付款 Controller
//   Author: Gray
//   createtime: 2017 / 03 / 16
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentPointController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService', 'PointService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService, PointService) {

        var getExtraFee = function() {

            $scope.isLoading = true;
            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                $scope.isLoading = false;

                if(result) {
                    $scope.extrafee = result;
                    $scope.orderid = $scope.extrafee.orderid;
                    
                    if($scope.extrafee.status != 300) {
                        scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        pay();
                    }

                } else {
                    $scope.isError = true;
                }

            }, function(error) {
                if(error && error.code == 'error.itemIsNotExist') {
                    $scope.isExtrafeeNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.extrafee) {
                return;
            }

            var extrafeeid = $scope.extrafeeid,
                paymentmethod = Paytype_Point,
                totalamount = $scope.extrafee.totalamount;

            ExtraFeeService.payExtraFee(extrafeeid, paymentmethod, totalamount).then(function(result) {
                if(result) {
                    $scope.isPaySuccess = true;
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;
            }, function(error) {

                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                getExtraFee();
            }, function(error) {
                $scope.isNoLogin = true;
                $scope.isLoading = false;
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.orderid = $stateParams.orderid;
        $scope.extrafee;
        $scope.isLoading = false;
        $scope.isStatusError = false;
        $scope.isError = false;
        $scope.isOrderNotExist = false;
        $scope.isPaySuccess = false;
        $scope.isNoLogin = false;
        $scope.pointsBalanceRec = PointService.lastPoint;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);